import React from 'react';
import { ElementConfigType } from '../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../HOC';

type Props = ElementConfigType;

const Text: React.FC<Props & { children: React.ReactNode }> = ({ privateSchema, children }) => {
  let renderText;
  if (privateSchema?.titleUrl) {
    renderText = (
      <a
        style={{
          fontSize: privateSchema?.fontSize,
          fontWeight: privateSchema?.fontWeight,
          color: privateSchema?.color ?? '#000',
          // textAlign: privateSchema?.textAlign,
          lineHeight: `${privateSchema?.lineHeight}px`,
          display: 'block',
        }}
        target="_blank"
        className="relative"
        href={privateSchema!.titleUrl}
        rel="noreferrer"
      >
        {children}
      </a>
    );
  } else {
    renderText = (
      <h2
        style={{
          fontSize: privateSchema?.fontSize,
          fontWeight: privateSchema?.fontWeight,
          color: privateSchema?.color,
          // textAlign: privateSchema?.textAlign,
          lineHeight: `${privateSchema?.lineHeight}px`,
        }}
        className="relative"
      >
        {children}
      </h2>
    );
  }
  return <>{renderText}</>;
};

export const TextTitleComponent: MyComponentType<Props> = (props: Props) => {
  const { privateSchema, config, id } = props;
  return (
    <div id={id}>
      <div
        className="flex flex-col"
        style={{
          alignItems: privateSchema?.textAlign,
        }}
      >
        <Text {...props}>{privateSchema?.text || config?.text}</Text>
        {privateSchema?.isShowUnderline && <div className="w-12 h-1 rounded-sm bg-black mt-4" />}
      </div>

      <a
        className="absolute right-1 inset-y-0 flex gap-2 items-center"
        href={privateSchema?.buttonUrl}
        target="_blank"
        rel="noreferrer"
        style={{
          color: privateSchema?.buttonTextColor,
          flexDirection: privateSchema?.iconFirst ? 'row-reverse' : 'row',
          fontSize: privateSchema?.buttonFontSize,
        }}
      >
        {privateSchema?.buttonText}
        {privateSchema?.buttonIcon?.[0]?.mediaSrc && (
          <img
            src={privateSchema?.buttonIcon?.[0]?.mediaSrc}
            className="w-6 h-6"
            style={{ width: privateSchema?.iconSize, height: privateSchema?.iconSize }}
          />
        )}
      </a>
    </div>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/TextTitleComponentDefinition'));

TextTitleComponent.definition = {
  // id: 'text-title-component',
  id: ComponentIdEnum.TEXT_TITLE_COMPONENT,
  name: '标题文本组件_1',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/dIVTg-dEwgXAOViujW2tP.png?image_process=resize,w_200',
  position: 6, // 显示顺序
  config: {
    text: 'Why Choose FEZiBO?',
  },
  privateSchema: {
    text: 'Why Choose FEZiBO?',
    fontSize: 30, // 16
    fontWeight: 600,
    // eslint-disable-next-line @iceworks/best-practices/recommend-add-line-height-unit
    lineHeight: 36, // 24
    isShowUnderline: true,
    textAlign: 'flex-start',
  },
  category: 'text',
  configForm: ConfigHOC(ConfigForm),
};
